import React from 'react';

export default function Card({ children, style, title, extra, padding = '20px', noPadding }) {
  return (
    <div style={{
      background: '#fff',
      borderRadius: 16,
      boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.02)',
      border: '1px solid #E2E8F0',
      overflow: 'hidden',
      transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
      ...style,
    }}>
      {title && (
        <div style={{
          padding: '16px 20px',
          borderBottom: '1px solid #F1F5F9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
        }}>
          <span style={{
            fontWeight: 700,
            fontSize: 15,
            color: '#0F172A',
            letterSpacing: '-0.01em',
          }}>{title}</span>
          {extra && <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>{extra}</div>}
        </div>
      )}
      <div style={{ padding: noPadding ? 0 : padding }}>{children}</div>
    </div>
  );
}
